import styled from 'styled-components'

import LazyImage from './LazyImage'

const Avatar = styled.div`
  position: relative;
  overflow: hidden;
  width: 40px;
  height: 40px;
  flex-shrink: 0;

  background-color: #ddd;
  border-radius: 50%;

  margin-right: 16px;

  ${LazyImage} {
    border-radius: 50%;
  }
`

export default Avatar
